"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _Pipes2 = _interopRequireDefault(require("./_Pipes"));
var _HotSpotBox = _interopRequireDefault(require("../Models/HotSpotBox"));
var _Device = _interopRequireDefault(require("../Models/Device"));
var _models = require("../../models");
var _useGetComponentsByParams = require("../../../hooks/store/useGetComponentsByParams");
var _constants = require("../../../utils/constants");
var _functions = require("../../../utils/functions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  LoopType,
  SectionTypes,
  sensorTypes,
  ComponentTypes
} = _paulCorePackage.constants;
const Item = props => {
  const {
    id = null,
    position = [0, 0, 0],
    isSecond = false
  } = props;
  const type = ComponentTypes.HtgHs;
  const {
    thingHtgHsType: {
      id: _typeKey
    } = {}
  } = (0, _useGetComponentsByParams.useGetComponentByTypeAndId)({
    type,
    id
  }) || {};
  // const {thingHtgHsType: { id: _typeKey } = {}} = {thingHtgHsType: { id: 1, value: {}}};
  const typeKey = _typeKey !== null && _typeKey !== void 0 ? _typeKey : _constants.htgHsConfig.N_A;
  const showBox = false;
  if (typeKey == null) console.log("".concat(type, ":thingPwhSupplyDeviceTypeId = ").concat(typeKey));
  const isKey = (0, _functions.isSomeComponentTypeKey)(typeKey);
  return (0, _react.useMemo)(() => typeKey !== _constants.htgHsConfig.N_A ? /*#__PURE__*/_react.default.createElement("group", {
    position: position
  }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 20, -8],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingFlow
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: id,
    thingLoopType: LoopType.secondary,
    thingSectionType: SectionTypes.flow,
    modelProps: {
      [sensorTypes.smartValve]: {
        deviceRotate: [-Math.PI / 2, -Math.PI / 2, 0]
      },
      [sensorTypes.energyValve]: {
        activeCable: _constants.activeCableDirection.bottom
      }
    },
    panelProps: {
      secondPosition: _constants.panelPosition.bottom
    }
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 10, -8],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingReturn
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: id,
    thingLoopType: LoopType.secondary,
    thingSectionType: SectionTypes.return,
    modelProps: {
      [sensorTypes.smartValve]: {
        deviceRotate: [-Math.PI / 2, -Math.PI / 2, 0]
      }
    }
    // requiredType={sensorTypes.energyValve}
    // anywayShow
  })), /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 0, -22]
  }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 15, 0],
    args: [6, 15, 6],
    showBox: showBox,
    visible: isKey(_constants.htgHsConfig.heatExchanger)
  }, /*#__PURE__*/_react.default.createElement(_models.HeatExchangerModel, {
    position: [0, 5, 0]
  })), /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 0, 2.2],
    visible: !isKey(_constants.htgHsConfig.heatExchanger)
  }, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 10, 0],
    scale: [1, 1, 0.9],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.heatingReturn
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 20, 0],
    scale: [1, 1, 0.9],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.heatingFlow
  }))), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 15, -22],
    args: [6, 15, 6],
    showBox: showBox,
    visible: isKey(_constants.htgHsConfig.hydraulicSwitch)
  }, /*#__PURE__*/_react.default.createElement(_models.HtgHsModel, {
    position: [0, 5, 0]
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 13, -24],
    args: [12, 27, 12],
    showBox: showBox,
    visible: isKey(_constants.htgHsConfig.bufferStorage)
  }, /*#__PURE__*/_react.default.createElement(_models.HeatBufferTankModel, {
    position: [0, -3, 0]
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 20, -43],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingFlow,
    visible: isKey([_constants.htgHsConfig.bufferStorage, _constants.htgHsConfig.hydraulicSwitch, _constants.htgHsConfig.heatExchanger])
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: id,
    thingLoopType: LoopType.primary,
    thingSectionType: SectionTypes.flow,
    modelProps: {
      [sensorTypes.smartValve]: {
        deviceRotate: [-Math.PI / 2, -Math.PI / 2, 0]
      },
      [sensorTypes.energyValve]: {
        activeCable: _constants.activeCableDirection.bottom
      }
    },
    panelProps: {
      secondPosition: _constants.panelPosition.bottom
    }
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 10, -35],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingReturn,
    visible: isSecond && isKey([_constants.htgHsConfig.bufferStorage, _constants.htgHsConfig.hydraulicSwitch, _constants.htgHsConfig.heatExchanger])
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: id,
    thingLoopType: LoopType.primary,
    thingSectionType: SectionTypes.return,
    modelProps: {
      [sensorTypes.smartValve]: {
        deviceRotate: [-Math.PI / 2, -Math.PI / 2, 0]
      }
    },
    requiredType: sensorTypes.pump,
    anywayShow: true
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 10, -43],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingReturn,
    visible: isKey([_constants.htgHsConfig.bufferStorage, _constants.htgHsConfig.hydraulicSwitch, _constants.htgHsConfig.heatExchanger])
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: id,
    thingLoopType: LoopType.primary,
    thingSectionType: SectionTypes.return,
    modelProps: {
      [sensorTypes.smartValve]: {
        deviceRotate: [-Math.PI / 2, -Math.PI / 2, 0]
      }
    },
    requiredTypeNot: sensorTypes.pump
    // requiredType={sensorTypes.smartValve}
    // anywayShow
  })), /*#__PURE__*/_react.default.createElement(_Pipes2.default, {
    position: [0, 0, 0]
  })) : /*#__PURE__*/_react.default.createElement("group", {
    position: position
  }, /*#__PURE__*/_react.default.createElement(_Pipes2.default, {
    position: [0, 0, 0]
  }), /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 0, -22]
  }, /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 0, 2.2],
    visible: true
  }, /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 10, 0],
    scale: [1, 1, 0.9],
    rotation: [0, 0, 0],
    highlightsType: "heatingReturn"
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 20, 0],
    scale: [1, 1, 0.9],
    rotation: [0, 0, 0],
    highlightsType: "heatingFlow"
  })))), [isKey, isSecond, showBox]);
};
var _default = exports.default = Item;